export function defineService(id) {
    return id;
}
export function implementService(_, factory) {
    return factory;
}
implementService.withConfig = function () {
    return function (_, factory) {
        return factory;
    };
};
